import { B_ORDER_YS } from '@/business'
import {
  ORDER_STATE_ENUM,
  ORDER_REFUND_STATE_ENUM,
  ORDER_MONEY_PAY_TYPE,
  OrderDetailActionType_ENUM,
  AllActionObjsInOrderDetail,
  ORDER_WORK_STATE_SHANG_HU_ENUM,
  IS_SELF_YUESAO
} from '@/config'
import {
  dateCompare,
  getDateByAddDay,
  isEmptyObject,
  isNonEmptyArray,
  isNullOrEmpty
} from '@/utils'
import { getOrderStatus } from '../../orderStatus'

export const getButtonList = vueInstance => {
  const {
    refundState,
    orderState,
    commentId,
    barcodeList,
    signSasInfo = {},
    signRefundInfo = {},
    isPayPeriod = '',
    workerType = 0,
    extInfo = []
  } = vueInstance.order || {}
  let isSelfYs = false //是否是甄选月撒
  const useRight = extInfo.find(item => item.labelKey === 'useRight')
  isSelfYs = useRight && +useRight.labelValue === IS_SELF_YUESAO
  const { sasState = 1 } = signSasInfo
  const { refundState: refundStatus } = signRefundInfo
  const workState = B_ORDER_YS.getWorkState(vueInstance.order)
  let btns = []
  if (ORDER_STATE_ENUM.CANCELED == orderState) {
    // 退款成功 btn：删除订单 （只有退款成功、已取消，才会有'删除订单'）
    btns.push(
      AllActionObjsInOrderDetail.get(OrderDetailActionType_ENUM.TO_DEL_ORDER)
    )
    return btns
  }

  if (ORDER_REFUND_STATE_ENUM.SUCCESSED == refundState) {
    // 退款成功 btn：删除订单 （只有退款成功、已取消，才会有'删除订单'）
    btns.push(
      AllActionObjsInOrderDetail.get(OrderDetailActionType_ENUM.TO_DEL_ORDER)
    )
    // 可能评价过后退款成功的
    commentId &&
      currStateActionBtns.push(
        AllActionObjsInOrderDetail.get(
          OrderDetailActionType_ENUM.TO_LOOK_COMMENTS
        )
      )
    return btns
  }

  if (B_ORDER_YS.isPendingPayment(orderState)) {
    // 待支付
    // 增加子状态，支付定金和支付尾款
    // // isPayPeriod:0 // 是否为定金尾款单 0 否 1 是

    if (
      ORDER_REFUND_STATE_ENUM.NOT_APPLIED == refundState ||
      ORDER_REFUND_STATE_ENUM.FAILED == refundState
    ) {
      // 未申请退款、退款失败时，才显示支付按钮
      // 申请退款中、退款成功（orderState已被变更为已取消）时，不显示支付按钮

      if (isPayPeriod === 0) {
        // 待付全款
        // 取消订单（相当于申请退款） \ 立即支付
        btns.push(
          AllActionObjsInOrderDetail.get(
            OrderDetailActionType_ENUM.TO_CANCEL_ORDER
          )
        )
        btns.push(
          AllActionObjsInOrderDetail.get(OrderDetailActionType_ENUM.TO_PAY)
        )
      } else {
        if (
          getOrderStatus(vueInstance.order) === ORDER_MONEY_PAY_TYPE.prePayOrder
        ) {
          // 待付定金
          // 取消订单（相当于申请退款） \ 支付定金
          btns.push(
            AllActionObjsInOrderDetail.get(
              OrderDetailActionType_ENUM.TO_CANCEL_ORDER
            )
          )
          btns.push(
            AllActionObjsInOrderDetail.get(
              OrderDetailActionType_ENUM.TO_PAY_PRE
            )
          )
        } else {
          // 已付定金、待付尾款
          // 退款操作(在最后单独处理) \ 支付尾款
          btns.push(
            AllActionObjsInOrderDetail.get(
              OrderDetailActionType_ENUM.TO_PAY_REST
            )
          )
          console.log(B_ORDER_YS.isDOOR2DOOR(workState), workState)
          //支付定金且月嫂已经申请上户 也显示确认上户按钮 只针对甄选月嫂
          if (B_ORDER_YS.isDOOR2DOOR(workState) && isSelfYs) {
            // 如果未申请退款 或者 退款失败 且是月嫂已申请上户状态 显示确认上户按钮
            if (
              B_ORDER_YS.isNotApplied(refundState) ||
              B_ORDER_YS.isRefundFailed(refundState)
            ) {
              // 确认上户
              btns.push(
                AllActionObjsInOrderDetail.get(
                  OrderDetailActionType_ENUM.TO_CONFIRM_YUESAO_DOOR2DOOR
                )
              )
            }
          }
        }
      }
    }
  } else if (B_ORDER_YS.is2BeServiced(orderState, workState)) {
    // * 用户已支付
    // * 等待月嫂服务
    // * 月嫂需要主动操作上户申请
  } else if (B_ORDER_YS.isHomeApplied(orderState, workState)) {
    // * 月嫂已经申请上户
    // * 待用户确认上户

    // 如果未申请退款 或者 退款失败 且是月嫂已申请上户状态 显示确认上户按钮
    if (
      B_ORDER_YS.isNotApplied(refundState) ||
      B_ORDER_YS.isRefundFailed(refundState)
    ) {
      // 确认上户
      btns.push(
        AllActionObjsInOrderDetail.get(
          OrderDetailActionType_ENUM.TO_CONFIRM_YUESAO_DOOR2DOOR
        )
      )
    }
  } else if (B_ORDER_YS.isInService(orderState, workState)) {
    //202209修改 只要支付成功和上户中 就显示核销按钮 只针对甄选月嫂
    if (isSelfYs) {
      btns.push(
        AllActionObjsInOrderDetail.get(
          OrderDetailActionType_ENUM.TO_CONFIRM_SERVICE_COMPLETED
        )
      )
    } else {
      // && 当前时间 > 上户时间 + 服务天数
      const confirm2HomeTime = B_ORDER_YS.getBarCodeInfo(
        vueInstance.order
      ).confirmHouseHoldTime
      const days = +vueInstance.order.serviceDays - 1
      const compareDate = getDateByAddDay(confirm2HomeTime, days)
      console.log(
        days,
        confirm2HomeTime,
        compareDate,
        compareDate.toLocaleDateString(),
        new Date(),
        new Date().toLocaleDateString()
      )
      if (dateCompare(new Date(), compareDate)) {
        // 确认服务完成
        btns.push(
          AllActionObjsInOrderDetail.get(
            OrderDetailActionType_ENUM.TO_CONFIRM_SERVICE_COMPLETED
          )
        )
      }
    }

    // 服务日志（新）
    btns.unshift(
      AllActionObjsInOrderDetail.get(
        OrderDetailActionType_ENUM.TO_READ_NEW_YUESAO_LOG
      )
    )
  } else if (B_ORDER_YS.isWaiting4Evaluation(orderState)) {
    // 立即评价
    btns.push(
      AllActionObjsInOrderDetail.get(OrderDetailActionType_ENUM.TO_COMMENT)
    )
  } else if (B_ORDER_YS.isFinishedAndEvaluated(orderState, commentId)) {
    // 查看评价
    btns.push(
      AllActionObjsInOrderDetail.get(
        OrderDetailActionType_ENUM.TO_LOOK_COMMENTS
      )
    )
  }

  if (
    (B_ORDER_YS.isPendingPayment(orderState) &&
      getOrderStatus(vueInstance.order) === ORDER_MONEY_PAY_TYPE.endPayOrder) ||
    B_ORDER_YS.is2BeServiced(orderState, workState) ||
    B_ORDER_YS.isHomeApplied(orderState, workState)
  ) {
    // 待支付尾款、待服务、待上户

    if (B_ORDER_YS.isNotApplied(refundState)) {
      // 未申请退款

      // 撤销退款 \ 申请退款
      btns.unshift(
        AllActionObjsInOrderDetail.get(
          B_ORDER_YS.hasAppliedRefund(refundStatus)
            ? OrderDetailActionType_ENUM.TO_CANCEL_APPLY_REFUND
            : OrderDetailActionType_ENUM.TO_APPLY_REFUND
        )
      )

      // 服务日志（新）
      btns.unshift(
        AllActionObjsInOrderDetail.get(
          OrderDetailActionType_ENUM.TO_READ_NEW_YUESAO_LOG
        )
      )
    }
  }

  if (
    (ORDER_STATE_ENUM.TO_BE_USED == orderState &&
      ORDER_REFUND_STATE_ENUM.NOT_APPLIED == refundState &&
      ORDER_WORK_STATE_SHANG_HU_ENUM.YI_QUEREN_SHANGHU == workState) ||
    (ORDER_STATE_ENUM.WAITING_4_EVALUATE == orderState &&
      ORDER_REFUND_STATE_ENUM.NOT_APPLIED == refundState) ||
    (ORDER_STATE_ENUM.FINISHED == orderState &&
      ORDER_REFUND_STATE_ENUM.NOT_APPLIED == refundState)
  ) {
    //  撤销售后 \ 申请售后
    btns.unshift(
      AllActionObjsInOrderDetail.get(
        B_ORDER_YS.hasAppliedAfterService(sasState)
          ? OrderDetailActionType_ENUM.TO_CANCEL_SERVICE_AFTER_SALE_YUESAO
          : OrderDetailActionType_ENUM.TO_APPLY_SERVICE_AFTER_SALE_YUESAO
      )
    )
  }

  return btns
}

/**
 * 房井洋
 * 用户未支付，可取消订单
 * 用户已支付，月嫂未申请上户，可申请退款，不露出，电话联系专属育儿顾问
 * 用户已支付，月嫂已申请上户, 用户可确认上户或拒绝上户申请
 * 月嫂已上户，露出 确认服务完成 以及 核销模块
 * 服务已完成，待评价，露出评价按钮
 * 服务已完成，已评价，露出查看评价按钮
 * 不删除订单
 * @param {Vue} vueInstance
 */
export const getButtonList_discard = vueInstance => {
  const {
    refundState,
    orderState,
    commentId,
    barcodeList,
    signSasInfo = {},
    signRefundInfo = {},
    isPayPeriod = '',
    workerType = 0
  } = vueInstance.order || {}
  const { sasState = 1 } = signSasInfo
  const { refundState: refundStatus } = signRefundInfo
  const workState = B_ORDER_YS.getWorkState(vueInstance.order)
  let btns = []
  // 待支付增加子状态，支付定金和支付尾款
  //     // isPayPeriod:0 // 是否为定金尾款单 0 否 1 是
  if (B_ORDER_YS.isPendingPayment(orderState)) {
    if (isPayPeriod === 0) {
      btns.push({
        class: ['btn-cancel'],
        action: E_ACTIONS.cancelOrder,
        txt: '取消订单'
      })
      btns.push({
        class: ['btn-pink'],
        action: E_ACTIONS.payOrder,
        txt: '立即支付'
      })
    } else {
      if (getOrderStatus(vueInstance.order) === ORDERTYPE.prePayOrder) {
        btns.push({
          class: ['btn-cancel'],
          action: E_ACTIONS.cancelOrder,
          txt: '取消订单'
        })
        btns.push({
          class: ['btn-pink'],
          action: E_ACTIONS.payOrder,
          txt: '支付定金'
        })
      } else {
        // 定金已申请退款 显示撤销退款
        if (
          B_ORDER_YS.hasAppliedRefund(refundStatus) &&
          B_ORDER_YS.isNotApplied(refundState)
        ) {
          // 前台已点击退款 &后台未点击退款
          btns.push({
            class: ['btn-refund'],
            action: E_ACTIONS.cancelRefund,
            txt: '撤销退款'
          })
        } else {
          if (!B_ORDER_YS.isApplied(refundState)) {
            // 非退款中的状态才展示
            if (B_ORDER_YS.hasAppliedRefund(refundStatus)) {
              btns.push({
                class: ['btn-refund'],
                action: E_ACTIONS.cancelRefund,
                txt: '撤销退款'
              })
            } else {
              btns.push({
                class: ['btn-refund'],
                action: E_ACTIONS.applyRefund,
                txt: '申请退款'
              })
            }

            btns.push({
              class: ['btn-pink'],
              action: E_ACTIONS.payOrder,
              txt: '支付尾款'
            })
          }
        }
      }
    }
  } else if (B_ORDER_YS.is2BeServiced(orderState, workState)) {
    // do noth
    if (!B_ORDER_YS.hasAppliedRefund(refundStatus)) {
      btns.push({
        class: ['btn-refund'],
        action: E_ACTIONS.applyRefund,
        txt: '申请退款'
      })
    } else if (
      B_ORDER_YS.hasAppliedRefund(refundStatus) &&
      !B_ORDER_YS.isApplied(refundState)
    ) {
      // 前台已点击退款 &后台未点击退款
      btns.push({
        class: ['btn-refund'],
        action: E_ACTIONS.cancelRefund,
        txt: '撤销退款'
      })
    }
  } else if (B_ORDER_YS.isHomeApplied(orderState, workState)) {
    // TODO 2.0
    // btns.push({
    //   class: ['btn-cancel'],
    //   action: E_ACTIONS.refuse2Home,
    //   txt: '拒绝上户',
    // })
    // 如果未申请退款 或者 退款失败 且是月嫂已申请上户状态 显示确认上户按钮
    if (
      B_ORDER_YS.isNotApplied(refundState) ||
      B_ORDER_YS.isRefundFailed(refundState)
    ) {
      // 如果没有点击过申请退款，这里会出现申请退款按钮
      if (!B_ORDER_YS.hasAppliedRefund(refundStatus)) {
        btns.push({
          class: ['btn-refund'],
          action: E_ACTIONS.applyRefund,
          txt: '申请退款'
        })
      } else if (
        B_ORDER_YS.hasAppliedRefund(refundStatus) &&
        !B_ORDER_YS.isApplied(refundState)
      ) {
        btns.push({
          class: ['btn-refund'],
          action: E_ACTIONS.cancelRefund,
          txt: '撤销退款'
        })
      }
      btns.push({
        class: ['btn-pink'],
        action: E_ACTIONS.confirm2Home,
        txt: '确认上户'
      })
    }
  } else if (B_ORDER_YS.isInService(orderState, workState)) {
    console.log(orderState, workState)
    // && 当前时间 > 上户时间 + 服务天数
    const confirm2HomeTime = B_ORDER_YS.getBarCodeInfo(
      vueInstance.order
    ).confirmHouseHoldTime
    const days = +vueInstance.order.serviceDays - 1
    const compareDate = getDateByAddDay(confirm2HomeTime, days)
    console.log(
      days,
      confirm2HomeTime,
      compareDate,
      compareDate.toLocaleDateString(),
      new Date(),
      new Date().toLocaleDateString()
    )
    // 如果没有点击过申请售后，这里会出现申请退款按钮
    if (!B_ORDER_YS.hasAppliedAfterService(sasState)) {
      btns.push({
        class: ['btn-refund'],
        action: E_ACTIONS.applyAfterService,
        txt: '申请售后'
      })
    } else if (
      B_ORDER_YS.hasAppliedAfterService(sasState) &&
      !B_ORDER_YS.isApplied(refundState)
    ) {
      btns.push({
        class: ['btn-refund'],
        action: E_ACTIONS.cancelAfterService,
        txt: '撤销售后'
      })
    }
    if (dateCompare(new Date(), compareDate)) {
      btns.push({
        class: ['btn-pink'],
        action: E_ACTIONS.complite,
        txt: '确认服务完成'
      })
    }
  } else if (B_ORDER_YS.isWaiting4Evaluation(orderState)) {
    btns.push({
      class: ['btn-pink'],
      action: E_ACTIONS.evaluate,
      txt: '立即评价'
    })
  } else if (B_ORDER_YS.isFinishedAndEvaluated(orderState, commentId)) {
    btns.push({
      class: ['btn-pink'],
      action: E_ACTIONS.viewEvaluation,
      txt: '查看评价'
    })
  }

  return btns
}

//服务是否完成  // && 当前时间 > 上户时间 + 服务天数
export const serviceCompleted = order => {
  const confirm2HomeTime = B_ORDER_YS.getBarCodeInfo(order).confirmHouseHoldTime
  const days = +order.serviceDays - 1
  const compareDate = getDateByAddDay(confirm2HomeTime, days)
  console.log(
    days,
    confirm2HomeTime,
    compareDate,
    compareDate.toLocaleDateString(),
    new Date(),
    new Date().toLocaleDateString()
  )
  return dateCompare(new Date(), compareDate)
}
